// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a2f65871","239":"278f3ea6","453":"61e310fd","732":"4acacd36"}[chunkId] + ".chunk.js";
};